import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Heart } from 'lucide-react';
import { getStats } from '../lib/api';

const Hero = () => {
  const [stats, setStats] = useState({
    athletes_helped: 200,
    provinces_reached: 15,
    success_rate: 85,
    years_active: 5,
  });

  useEffect(() => {
    getStats()
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1526232761682-d26e03ac148e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx5b3VuZyUyMHNvY2NlciUyMHBsYXllcnMlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODI2ODIzNjl8MA&ixlib=rb-4.1.0&q=85"
          alt="Jóvenes deportistas entrenando"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-sky-900/95 via-sky-800/90 to-sky-700/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2 mb-8">
            <Heart className="w-4 h-4 text-white" />
            <span className="text-white text-sm font-medium">Construyendo el futuro del deporte argentino</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Transformando
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white to-sky-200">
              Sueños en Realidad
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl sm:text-2xl text-sky-100 mb-12 leading-relaxed max-w-3xl">
            Ayudamos a jóvenes deportistas del interior de Argentina a desarrollar su potencial y alcanzar el
            profesionalismo. Tu empresa puede ser parte de este cambio.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollToSection('donar')}
              size="lg"
              className="bg-white text-sky-900 hover:bg-sky-50 text-lg px-8 py-6 shadow-2xl hover:shadow-3xl transition-all duration-300 group"
            >
              Donar Ahora
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection('colaborar')}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-sky-900 text-lg px-8 py-6 transition-all duration-300"
            >
              Conocé Cómo Colaborar
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 mt-16 pt-16 border-t border-white/20">
            <div>
              <div data-testid="hero-stat-athletes" className="text-4xl sm:text-5xl font-bold text-white mb-2">
                {stats.athletes_helped}+
              </div>
              <div className="text-sky-200 text-sm sm:text-base">Atletas Apoyados</div>
            </div>
            <div>
              <div data-testid="hero-stat-provinces" className="text-4xl sm:text-5xl font-bold text-white mb-2">
                {stats.provinces_reached}
              </div>
              <div className="text-sky-200 text-sm sm:text-base">Provincias Alcanzadas</div>
            </div>
            <div>
              <div data-testid="hero-stat-success" className="text-4xl sm:text-5xl font-bold text-white mb-2">
                {stats.success_rate}%
              </div>
              <div className="text-sky-200 text-sm sm:text-base">Tasa de Éxito</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
